import React, {useEffect} from 'react';
import {motion, useAnimation} from 'framer-motion';
import {useInView} from 'react-intersection-observer';

export default function Footer() {
  const controls = useAnimation();
  const {ref, inView, entry} = useInView();

  const animation = {
    hidden: {
      y: '50%',
      transition: {
        duration: 0.5,
      },
    },
    visible: {
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
    if (!inView) {
      controls.start('hidden');
    }
  }, [controls, inView]);

  return (
    <motion.footer
      ref={ref}
      initial='hidden'
      animate={controls}
      variants={animation}
      className='footer'
    >
      <div className='footer__container container'>
        <h1 className='footer__title'>Andrez R.</h1>
        <ul className='footer__list'>
          <li>
            <a href='#home' className='footer__link'>
              Home
            </a>
          </li>
          <li>
            <a href='#about' className='footer__link'>
              About
            </a>
          </li>
          <li>
            <a href='#skills' className='footer__link'>
              Skills
            </a>
          </li>
          <li>
            <a href='#Services' className='footer__link'>
              Services
            </a>
          </li>
          <li>
            <a href='#work' className='footer__link'>
              Recent projects
            </a>
          </li>
          <li>
            <a href='#contact' className='footer__link'>
              Contact
            </a>
          </li>
        </ul>
        <ul className='footer__social'>
          <a
            href='https://www.linkedin.com/in/andrezramirez/'
            target='_blank'
            className='footer__social-link'
          >
            <i className='bx bxl-linkedin-square'></i>
          </a>
          <a
            href='https://github.com/andrezzz2312'
            target='_blank'
            className='footer__social-link'
          >
            <i className='bx bxl-github'></i>
          </a>

          <a
            href='https://www.instagram.com/drewzzzart/'
            target='_blank'
            className='footer__social-link'
          >
            <i className='bx bxl-instagram'></i>
          </a>
        </ul>
        <h1 className='footer__message'>Thanks for stepping by!</h1>
        <span className='footer__copy'>
          &#169; Andrez R. All rights reserved
        </span>
      </div>
    </motion.footer>
  );
}
